import type { ConversationMessage } from "@dreamverse/contracts";
import { IconPower } from "../../components/Icons";

function formatCny(priceCents: number): string {
  return (priceCents / 100).toFixed(2).replace(/\.00$/, "");
}

/** 对话时间线里的非发言事件，不冒充用户或角色气泡。 */
export function SystemEventBar({ message }: { message: ConversationMessage }) {
  const event = message.systemEvent;
  if (!event) return null;

  switch (event.type) {
    case "power_topup_fulfilled":
      return (
        <div
          className="system-event"
          role="note"
          aria-label={`充值到账，支付 ${formatCny(event.priceCents)} 元，获得 ${event.grantedPower} 点灵力`}
        >
          <span className="system-event__line" aria-hidden />
          <span className="system-event__pill">
            <IconPower size={14} />
            <span>充值到账</span>
            <span className="system-event__dot" aria-hidden>·</span>
            <span>{formatCny(event.priceCents)}元</span>
            <span className="system-event__dot" aria-hidden>·</span>
            <strong>+{event.grantedPower}灵力</strong>
          </span>
          <span className="system-event__line" aria-hidden />
        </div>
      );
  }
}
